module.exports = __webpack_public_path__ + "img/5-heat-pump.e923d518.svg";